import ApplicationAdapter from 'eflex/adapters/application';

export default class GroupAdapter extends ApplicationAdapter {
  namespace = 'locations';
}
